import Rollbar from 'rollbar';

export const isRollbarInit = process.env.NODE_ENV === 'production' && process.env.ROLLBAR_HOST;

export const pushRollbarError = (error, info) => {
    if (isRollbarInit) {
        Rollbar.configure({
            payload: {
                info
            }
        });
        Rollbar.error(error.message, error);
    } else {
        // eslint-disable-next-line
        console.error(error);
    }
};
